import styled from 'styled-components';

interface LeftMenuProps {
  isOpen?: boolean;
  isTrial?: boolean;
}

export const LeftMenuContainer = styled.div<LeftMenuProps>`
  margin-top: ${({ isTrial }) => (isTrial ? ' 60px' : '0')};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ isOpen }) => (isOpen ? '360px' : '0')};
  height: fit-content;
  padding: 32px 0;
  border-radius: 0 16px 16px 0;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  transition: all 0.3s ease;

  .sidebarContentWrapper {
    display: flex;
    flex-direction: column;
    gap: 60px;
    width: 100%;
    overflow: hidden;

    .menuItems {
      display: flex;
      justify-content: center;

      nav {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
        width: 100%;

        > ul {
          display: flex;
          flex-direction: column;
          justify-content: center;
          list-style: none;
          width: 100%;
        }
      }
    }

    .help {
      overflow: hidden;
      display: grid;
      align-content: center;
      align-items: center;
      grid-template-columns: 32px auto;
      gap: 16px;

      width: 100%;
      padding: 12px 18px;
      border: none;
      background: none;
      color: ${({ theme }: {theme: any}) => theme.black};
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: ${({ theme }: {theme: any}) => theme.themePrimary};

        span,
        svg {
          color: #fff;
        }
      }

      span {
        opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
        visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 32px;

        font: 300 1rem/1.2rem 'Roboto', sans-serif;
        white-space: nowrap;
        transition: all 0.3s ease;
      }

      > svg {
        color: ${({ theme }: {theme: any}) => theme.themePrimary};
        height: 32px;
        width: 32px;
        transition: all 0.3s ease;
      }
    }
  }
`;

export const LeftMenuHeader = styled.div<LeftMenuProps>`
  display: flex;
  justify-content: ${({ isOpen }) => (isOpen ? 'space-between' : 'center')};
  align-items: center;
  width: 100%;
  padding: ${({ isOpen }) => (isOpen ? '0 24px' : '0')};
  margin-bottom: 32px;

  h1 {
    font: 700 0.7rem/2rem 'Roboto', sans-serif;
    text-transform: uppercase;
    width: 100%;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
    letter-spacing: 0.5px;
    white-space: nowrap;
  }
`;

export const CollapseButton = styled.button<LeftMenuProps>`
  margin-top: ${({ isTrial }) => (isTrial ? ' 60px' : '0')};

  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(50%)')};
  border: none;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  padding: 6px;
  border-radius: 0 16px 16px 0;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    height: 32px;
    width: 32px;
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
    transition: all 0.3s ease;
  }
`;

export const LeftMenuSkeleton = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 18px;
  gap: 24px;
`;
export const MenuItemSkeleton = styled.div`
  width: 100%;
  height: 32px;
  border-radius: 16px;
  background: ${({ theme }: {theme: any}) => theme.neutralLight};
`;
